import React from "react";
import Blogs from "../../components/Blogs";
import CaseStudy from "../../components/CaseStudy";
import InnerBanner from "../../components/InnerBanner";

const Resources = () => {
  return (
    <>
      <InnerBanner title="Resources"/>
      <CaseStudy/>
      <Blogs/>
    </>
  );
};

export default Resources;
